import { useHead } from '@unhead/react';
import { useTranslation } from 'translations/hooks';

import { SingleCardPageWithFilterCardLayout } from 'business/layout/single-card-page-with-filter-card';
import { TableParamsProvider } from 'business/providers/table-params';
import { DEFAULT_PAGE_SIZE } from 'business/quality-control/constants';
import { useFilterData } from 'technical/filter-data';
import { useMediaType } from 'technical/media/hooks';
import { CustomFilterCard } from 'ui/filter-card';
import { SelectedItemsFooter } from 'ui/filter-footer';

import { DefectReportTable } from './components/defect-report-table';
import { DefectReportFilters } from './components/filters';
import { DefectReportHistoryHeader } from './components/header';
import { MobileDefectReportHistoryPage } from './mobile';
import {
  defaultFilters,
  DefectReportHistoryFiltersProvider,
} from './providers/filters';

export const ORDER_FIELD = 'reportDate';
export const ORDER_TYPE = 'descend';

export interface DefectReportHistoryFilterData {
  selectedDefectReports?: number;
}

export function DefectReportHistoryPage() {
  const { t } = useTranslation();

  const { filterData, setFilterData } =
    useFilterData<DefectReportHistoryFilterData>();

  useHead({
    title: t('user.menu.sections.qualityControl.defectReportHistory.title'),
  });

  const { isMobile } = useMediaType();

  if (isMobile) {
    return <MobileDefectReportHistoryPage />;
  }

  return (
    <TableParamsProvider
      defaultPageSize={DEFAULT_PAGE_SIZE}
      defaultSortField={ORDER_FIELD}
      defaultSortOrder={ORDER_TYPE}
    >
      <DefectReportHistoryFiltersProvider initialFilters={defaultFilters}>
        <SingleCardPageWithFilterCardLayout
          title={t(
            'user.menu.sections.qualityControl.defectReportHistory.title',
          )}
          header={<DefectReportHistoryHeader />}
          filters={
            <CustomFilterCard
              footer={
                filterData?.selectedDefectReports ? (
                  <SelectedItemsFooter>
                    {t('qualityControl.defectReportHistory.selectedItems', {
                      selectedDefectReports: filterData?.selectedDefectReports,
                    })}
                  </SelectedItemsFooter>
                ) : null
              }
            >
              <DefectReportFilters />
            </CustomFilterCard>
          }
        >
          <DefectReportTable setFilterData={setFilterData} />
        </SingleCardPageWithFilterCardLayout>
      </DefectReportHistoryFiltersProvider>
    </TableParamsProvider>
  );
}
